import React from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { fetchArea } from "services/dropdown";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";

const AreaDropdown = ({
  errors,
  control,
  setValue,
  getValues,
  watch,
  required
}) => {
  const areaName = getValues().area_name;
  const selectedArea = watch("area_id");

  const {
    data: areas,
    isLoading,
    error,
  } = useQuery(["areas"], () => fetchArea(), {
    keepPreviousData: false,
    staleTime: DROPDOWN_STALE_TIME,
  });

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading Areas</div>;

  const modifiedData = areas?.data?.data?.map((ele) => ({
    ...ele,
    area_id: ele.id,
  }));

  const options =
    modifiedData?.map((area) => ({
      value: area.area_id,
      label: area.area_name,
    })) || [];

  const selectedOption = options.find(
    (option) => option.value === selectedArea || areaName
  );

  return (
    <Controller
      name="area_id"
      control={control}
      rules={{
        required: required ? "Area is required" : false,
        validate: (value) => {
          if (required && !value) return "Area is required";
          return true;
        },
      }}
      render={({ field }) => (
        <Select
          {...field}
          options={options}
          isClearable
          placeholder="Select Area"
          menuPortalTarget={document.body}
          value={selectedOption || null}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
          onChange={(selectedOption) => {
            const value = selectedOption ? selectedOption.value : "";
            field.onChange(value);
            setValue("area_id", value);
          }}
          className={`react-select-container ${errors.area_id ? "is-invalid" : ""}`}
        />
      )}
    />
  );
};

export default AreaDropdown;

